import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Copy, Check, ExternalLink, Eye, ShieldCheck } from 'lucide-react';

// Los tokens no se imprimen por defecto, en ningún ambiente.
const ProtectedResumeLink = ({ url, testid = 'resume-link' }) => {
  const [copied, setCopied] = useState(false);
  const [failed, setFailed] = useState(false);
  const [revealed, setRevealed] = useState(false);

  const copy = async () => {
    setFailed(false);
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(url);
      } else {
        const ta = document.createElement('textarea');
        ta.value = url;
        ta.setAttribute('readonly', '');
        ta.style.position = 'absolute';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        const ok = document.execCommand('copy');
        document.body.removeChild(ta);
        if (!ok) throw new Error('fallback-failed');
      }
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    } catch (e) {
      setFailed(true);
    }
  };

  const reveal = () => {
    setRevealed(true);
    setTimeout(() => setRevealed(false), 20000);
  };

  return (
    <div className="space-y-2" data-testid={testid}>
        <div
          data-testid={`${testid}-protected`}
          className="flex items-center gap-2 text-xs bg-gray-100 border border-gray-200 rounded p-2 text-gray-700"
        >
          <ShieldCheck className="h-4 w-4 text-gray-500" />
          Enlace personal y temporal
        </div>

      <div className="flex flex-wrap gap-2">
        <Button type="button" variant="outline" size="sm" onClick={copy} data-testid={`${testid}-copy`} aria-live="polite">
          {copied ? <Check className="h-4 w-4 mr-2 text-green-600" /> : <Copy className="h-4 w-4 mr-2" />}
          {copied ? 'Enlace copiado' : 'Copiar enlace'}
        </Button>
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={() => window.open(url, '_blank', 'noopener,noreferrer')}
          data-testid={`${testid}-open`}
        >
          <ExternalLink className="h-4 w-4 mr-2" /> Completar mi expediente
        </Button>
        {failed && !revealed && (
          <Button type="button" variant="ghost" size="sm" onClick={reveal} data-testid={`${testid}-reveal-action`}>
            <Eye className="h-4 w-4 mr-2" /> Revelar temporalmente
          </Button>
        )}
      </div>

      {failed && (
        <p data-testid={`${testid}-fallback`} className="text-xs text-gray-700">
          No se pudo copiar automáticamente. Usa “Revelar temporalmente” para copiarlo a mano.
        </p>
      )}
      {revealed && (
        <code data-testid={`${testid}-revealed`} className="block text-xs bg-gray-50 border border-gray-200 rounded p-2 break-all">
          {url}
        </code>
      )}
      <p className="text-[11px] text-gray-500">
        Este enlace es <strong>personal y temporal</strong>; no lo compartas ni lo incluyas en capturas.
        Si caduca, usa “Renovar enlace”.
      </p>
    </div>
  );
};

export default ProtectedResumeLink;
